import { IAssignment } from '@medely/types';
import { Box, Heading, HStack, Text } from '@medely/ui-kit';
import React from 'react';
import * as R from 'ramda';

type AssignmentCompensationPayRatesProps = {
  assignment: IAssignment;
};

type AssignmentCompensationPayRatesItemProps = {
  title: string;
  info: string;
};

const money = (cents: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(cents / 100);
const suffix = R.flip(R.concat);
const rate = R.o(suffix('/hr'), money);
const weekPay = R.o(suffix('/wk'), money);

const breakdown = (assignment: IAssignment & { assignment_request?: any }) =>
  [
    ['Regular (Taxable) Hourly Rate', rate(assignment.payout_taxable_hourly_rate_cents)],
    [
      'Overtime Rate',
      rate(assignment.payout_taxable_hourly_rate_cents * assignment.payout_overtime_multiplier),
    ],
    [
      'Holiday Rate',
      rate(assignment.payout_taxable_hourly_rate_cents * assignment.payout_overtime_multiplier),
    ],
    ['On Call Rate', rate(assignment.payout_on_call_hourly_rate_cents)],
    [
      'Call Back Rate',
      rate(assignment.payout_taxable_hourly_rate_cents * assignment.payout_overtime_multiplier),
    ],
    [
      'Per Diem stipend (full week)',
      weekPay(7 * (assignment.mie_per_diem_cents + assignment.lodging_per_diem_cents)),
    ],
  ].filter(Boolean) as Array<[string, string]>;

const AssignmentCompensationPayRatesItem = ({
  title,
  info,
}: AssignmentCompensationPayRatesItemProps) => {
  return (
    <HStack justifyContent="space-between" pt={1}>
      <Text size="m" color="text.secondary">
        {title}
      </Text>
      <Text size="m" color="text.secondary">
        {info}
      </Text>
    </HStack>
  );
};

export const AssignmentCompensationPayRates = ({
  assignment,
}: AssignmentCompensationPayRatesProps) => {
  const items = breakdown(assignment);

  return (
    <Box py={2}>
      <Heading size="xs">Pay Rates</Heading>
      {items.map(([value, label]) => (
        <Box key={label}>
          <AssignmentCompensationPayRatesItem info={label} title={value} />
        </Box>
      ))}
    </Box>
  );
};
